import { render, staticRenderFns } from "./EditRefreshment.vue?vue&type=template&id=6ac2ffc6&scoped=true&"
import script from "./EditRefreshment.vue?vue&type=script&lang=js&"
export * from "./EditRefreshment.vue?vue&type=script&lang=js&"
import style0 from "./EditRefreshment.vue?vue&type=style&index=0&id=6ac2ffc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac2ffc6",
  null
  
)

component.options.__file = "EditRefreshment.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VCardActions,
  VCardText,
  VCardTitle,
  VDialog,
  VDivider,
  VForm,
  VIcon,
  VTextField,
})
